<button mat-icon-button (click)="showMessages()">
    <mat-icon 
        fontSet="fa" fontIcon="fa-envelope"
        [matBadge]="newMessageCount"
        matBadgePosition="below after"
        matBadgeSize="medium"
        [matBadgeHidden]="!newMessageCount"
        title="{{ (newMessageCount > 0 ? 'messages.title.unread_messages' : 'messages.title.messages') | translate : { 'amount': newMessageCount } }}">
    </mat-icon>
</button>